var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer col-xs-12"},[_c('p',{staticClass:"footer-text"},[_vm._v(_vm._s(_vm.$t('haveQuestions'))+"?")]),_c('p',{staticClass:"footer-para"},[_vm._v(" "+_vm._s(_vm.$t('marketPlaceFooterText'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }